// Note that these strings differ in Internet Explorer,
// Those strings get shimmed in polyfills.ts (shim-keyboard-event-key)
// if that shim is removed, these values will be wrong in IE.
export enum KeyboardEventKeys {
  arrowUp = 'ArrowUp',
  arrowRight = 'ArrowRight',
  arrowDown = 'ArrowDown',
  arrowLeft = 'ArrowLeft',
  tab = 'Tab',
  esc = 'Escape',
  enter = 'Enter',
  space = ' ',
  home = 'Home',
  end = 'End'
}
